import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]

  // Enable the disabled "Continue" button once a delivery option is chosen.
  enableSubmit() {
    this.submitTarget.disabled = false
  }
}
